import { GetPageByRouteQuery } from "apollo"
import { BlockRenderer } from "ui"
import { getBreadCrumbs, transformProperties } from "utils"
import TermsLayout from "./TermsLayout"

type Props = {
  data: GetPageByRouteQuery
  locale: string
}

const components = {
  mainTitleBlock: () => import("./MainTitle"),
  anchorMenu: () => import("../EggedTransportation/AnchorMenu"),
  tabsContent1: () => import("../EggedTransportation/TabsWithAnchor"),
  titleTextAndMediaBlock: () => import("./TitleTextAndMedia"),
}

const Terms = ({ data, locale }: Props) => {
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  const breadCrumbs = getBreadCrumbs(data, locale)
  const anchorBlock =
    blocks?.blocks?.find((block: any) => block.blockType === "anchorMenu") ||
    null
  return (
    <TermsLayout breadCrumbs={breadCrumbs}>
      {blocks?.blocks?.map(
        // TO DO : HOW TO FIND BLOCK TYPE IN GENERATED GRAPHQL TYPES
        (block: any, index: number) => {
          let extraProps = {}
          if (block.blockType === "tabsContent1") {
            extraProps = {
              anchorBlock,
              containerEnabled: false,
            }
          }
          return (
            <BlockRenderer
              key={index}
              blockType={block.blockType}
              blockData={block}
              components={components}
              locale={locale}
              props={{ breadCrumbs, ...extraProps }}
            />
          )
        },
      )}
    </TermsLayout>
  )
}

export default Terms
